<template>
  <ReportItemContainer v-if="isReportMode">
    <template #question>{{ question.text }}</template>
    <template #answer>
      <p>{{ inputText }}</p>
    </template>
  </ReportItemContainer>
  <div v-else>
    <PPhoneInput
      :label="question.text"
      :value="inputText"
      :disabled="isReadOnlyMode"
      @update-event="
        (val) => {
          inputText = val;
          emitNewValue();
        }
      "
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import ReportItemContainer from "@/components/containers/ReportItemContainer.vue";
import type { QuestionModelDto } from "@/models/dto/questionModelDto";
import PPhoneInput from "@/components/custom/PPhoneInput.vue";

const props = withDefaults(
  defineProps<{
    questionModel: QuestionModelDto;
    answer?: string | object | null;
    error?: string;
    isReportMode?: boolean;
    isReadOnlyMode?: boolean;
  }>(),
  {
    error: "",
    isReportMode: false,
    isReadOnlyMode: false,
  }
);

const emit = defineEmits<{
  (e: "qEvent", newValue: string): void;
}>();

const question = computed(() => props.questionModel?.question);
const inputText = ref(
  (props.answer as unknown as string) ?? question.value.defaultValue
);
const finalInputText = computed(() =>
  inputText.value || inputText.value.length > 0
    ? inputText.value
    : question.value.defaultValue + inputText.value
);

function emitNewValue(): void {
  inputText.value = finalInputText.value;
  emit("qEvent", finalInputText.value);
}
</script>
